import { combineReducers } from 'redux';
import { cardSelectedMiddleware } from './card-selected/card-selected.middleware';
import { cardSelectedReducers } from './card-selected/card-selected.state';
import { cardInterfaceMiddleware } from './interface/card-interface.middleware';
import { cardInterfaceReducers } from './interface/card-interface.state';
import { cardDismissReducers } from './dismiss/dismiss.state';
import { cardDismissMiddlewares } from './dismiss/dismiss.middlewares';

export const cardsMiddlewares = [
    cardSelectedMiddleware,
    cardInterfaceMiddleware,
    cardDismissMiddlewares,
];

export const cardsReducer = combineReducers({
    cardSelected: cardSelectedReducers,
    interface: cardInterfaceReducers,
    dismiss: cardDismissReducers,
});
